<script setup lang="ts">
import { OperatorType } from '~/apiClient';

const { tt } = useTypedI18n();

type Option = { value: OperatorType; label: TypedTranslateReturn };

const options: Option[] = [
    { value: OperatorType.Dealer, label: tt('signup.fields.type.Dealer') },
    { value: OperatorType.PeopleTransportOperator, label: tt('signup.fields.type.PeopleTransportOperator') },
    { value: OperatorType.Scrapyard, label: tt('signup.fields.type.Scrapyard') },
    { value: OperatorType.Other, label: tt('signup.fields.type.Other') },
];

const model = defineModel<OperatorType | undefined>();
</script>

<template>
    <USelectMenu v-model="model" :items="options" value-key="value" :search-input="false" />
</template>
